import type { LegalSection } from '../../content/legal/legalMeta';

export type LegalSectionViewProps = {
  section: LegalSection;
};

export function LegalSectionView({ section }: LegalSectionViewProps) {
  return (
    <section id={section.id} aria-labelledby={`${section.id}-heading`}>
      <h2
        id={`${section.id}-heading`}
        className="text-xl font-bold text-[#111818] mb-3 font-display"
      >
        {section.title}
      </h2>
      {section.paragraphs.map((paragraph) => (
        <p key={paragraph.slice(0, 48)} className="text-base text-[#334444] leading-relaxed mb-3">
          {paragraph}
        </p>
      ))}
      {section.listItems && section.listItems.length > 0 ? (
        <ul className="list-disc pl-6 space-y-2 text-base text-[#334444] leading-relaxed">
          {section.listItems.map((item) => (
            <li key={item.slice(0, 48)}>{item}</li>
          ))}
        </ul>
      ) : null}
    </section>
  );
}
